export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'
export const USER_LOGOUT = 'USER_LOGOUT'
export const AUTH_ALERT = 'AUTH_ALERT'
export const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS'
export const GET_USER_DETAIL_FAILED = 'GET_USER_DETAIL_FAILED'
export const GET_USER_DETAIL_REQUEST = 'GET_USER_DETAIL_REQUEST'
